import fetch from 'isomorphic-fetch';
import fetchTranslations from './fetchTranslations';
import moment from 'moment';
import fetchAPI from 'utils/fetchAPI';
import * as api from '../../api';

export const SET_TRANSLATIONS = 'SET_TRANSLATIONS';
export const SET_LOCALE = 'SET_LOCALE';

export const LOCALE = {
  EN: 'en',
  ZH: 'zh',
  JA: 'ja',
};

function setLocale(locale = LOCALE.EN) {
  return {
    type: SET_LOCALE,
    locale,
  };
}

function setTranslations(translations) {
  return {
    type: SET_TRANSLATIONS,
    translations,
  };
}

export function changeLocale(locale = LOCALE.EN) {
  return (dispatch, getState) =>
    new Promise(() => {
      const translations = fetchTranslations(locale);
      dispatch(setTranslations(translations));
      dispatch(setLocale(locale));
      api.user.updateLanguage(locale);
      // need update logic when introducing new languague
      if (locale === LOCALE.ZH || locale.startsWith('zh')) {
        moment.locale('zh-cn');
      } else if (locale === LOCALE.JA || locale.startsWith('ja')) {
        moment.locale('ja');
      } else {
        moment.locale('en');
      }
    });
}

export function translate(key, defaultString = '') {
  return (dispatch, getState) =>
    new Promise(() => {
      const locale = getState().i18n.locale;
      let translations = getState().i18n.translations;

      if (Object.keys(translations).length) {
        return translations[key];
      }
      translations = fetchTranslations(locale);
      dispatch(setTranslations(translations));
      return defaultString;
    });
}



// WEBPACK FOOTER //
// ./app/actions/translations/index.js